import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: 7 }, "7", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  value: 13,
  selected: "selected"
}, "13", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: 20 }, "20", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Precision: "),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.precision) = $event)),
      disabled: $setup.is_running
    }, _hoisted_5, 8 /* PROPS */, _hoisted_1), [
      [_vModelSelect, $setup.precision]
    ])
  ]))
}